module.exports = __webpack_public_path__ + "img/calc_on.d12901d5.svg";